const focalPointToPosition = (focalPoint?: number[]) => {
    if (focalPoint) {
        const [x, y] = focalPoint;
        return `${Math.round(x * 100)}% ${Math.round(y * 100)}%`;
    }
    return 'unset';
};
export default focalPointToPosition;
